import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatDateToDDMMYYYY } from '../../utils/dateUtils';
import './GeneralLoanDueReport.css';

const GeneralLoanDueReport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5012';

  useEffect(() => {
    fetchReportData();
  }, []);

  const fetchReportData = async () => {
    setLoading(true);
    try {
      const params = {};
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const response = await axios.get(`${baseUrl}/api/general-loan-due-report`, { params });
      setReportData(response.data || []);
    } catch (error) {
      console.error('Error fetching due report:', error);
      alert('Error fetching due report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDateFilter = () => {
    fetchReportData();
  };

  const handleReset = () => {
    setFromDate('');
    setToDate('');
    fetchReportData();
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="due-report-container">
      <div className="due-report-header">
        <h2>General Loan Due Report</h2>
        <button onClick={handleBack} className="back-btn">Back</button>
      </div>

      <div className="date-filter-section">
        <div className="date-inputs">
          <div className="date-input-group">
            <label>From Date:</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="date-input-group">
            <label>To Date:</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="date-actions">
            <button onClick={handleDateFilter} className="filter-btn">
              Filter
            </button>
            <button onClick={handleReset} className="reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="report-table-container">
          <table className="due-report-table">
            <thead>
              <tr>
                <th>Account No</th>
                <th>Loanee Name & Phone</th>
                <th>Guarantor Name & Phone</th>
                <th>Due Dates</th>
                <th>Due Balance</th>
                <th>Outstanding Balance</th>
              </tr>
            </thead>
            <tbody>
              {reportData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">No due records found</td>
                </tr>
              ) : (
                reportData.map((row) => (
                  <tr key={row.account_no}>
                    <td>{row.account_no}</td>
                    <td className="name-phone-cell">
                      <div className="name">{row.loanee_name}</div>
                      <div className="phone">{row.phone_debtor}</div>
                    </td>
                    <td className="name-phone-cell">
                      <div className="name">{row.guarantor_name}</div>
                      <div className="phone">{row.phone_guarantor}</div>
                    </td>
                    <td className="due-dates-cell">
                      {row.due_dates && row.due_dates.length > 0 ? (
                        row.due_dates.map((due, idx) => (
                          <div key={idx} className="due-date-item">
                            {formatDateToDDMMYYYY(due.due_date)}
                          </div>
                        ))
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                    <td className="due-balance-cell">
                      {row.due_dates && row.due_dates.length > 0 ? (
                        row.due_dates.map((due, idx) => (
                          <div key={idx} className="due-balance-item">
                            ₹{due.remaining_amount.toFixed(2)}
                          </div>
                        ))
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                    <td className="outstanding-balance">
                      ₹{row.outstanding_balance.toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GeneralLoanDueReport;

